import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UploadConfig } from "../../api/services/coreService";
import { OpsType } from "../../types";

interface OpsConfig {
  name: string;
  displayName: string;
  dbName?: string;
  color: string;
  screens?: string[];
  uploads?: UploadConfig[];
}

interface OpsState {
  currentOps: OpsType | null;
  availableOps: OpsType[];
  opsConfigs: Record<string, OpsConfig>;
  fetchingConfigs: Record<string, boolean>;
}

// Default configurations for known operations (display info only)
const defaultOpsConfigs: Record<string, OpsConfig> = {
  rayo: {
    name: "rayo",
    displayName: "Rayo",
    color: "#ff5722",
    // dbName and screens will be fetched from API
  },
  indrive: {
    name: "indrive",
    displayName: "InDrive",
    color: "#2196f3",
    // dbName and screens will be fetched from API
  },
  logus: {
    name: "logus",
    displayName: "Logus",
    color: "#4caf50",
    // dbName and screens will be fetched from API
  },
  muve: {
    name: "muve",
    displayName: "Muve",
    color: "#9c27b0",
    // dbName and screens will be fetched from API
  },
  bee: {
    name: "bee",
    displayName: "Bee",
    color: "#ff9800",
    // dbName and screens will be fetched from API
  },
  agility: {
    name: "agility",
    displayName: "Agility",
    color: "#607d8b",
    // dbName and screens will be fetched from API
  },
  entrego: {
    name: "entrego",
    displayName: "Entrego",
    color: "#e91e63",
    // dbName and screens will be fetched from API
  },
};

const initialState: OpsState = {
  currentOps: "gestor",
  availableOps: [],
  opsConfigs: defaultOpsConfigs,
  fetchingConfigs: {},
};

const opsSlice = createSlice({
  name: "ops",
  initialState,
  reducers: {
    setCurrentOps: (state, action: PayloadAction<OpsType>) => {
      state.currentOps = action.payload;
    },
    setAvailableOps: (state, action: PayloadAction<OpsType[]>) => {
      state.availableOps = action.payload;
    },
    addOpsConfig: (
      state,
      action: PayloadAction<{ ops: string; config: OpsConfig }>
    ) => {
      state.opsConfigs[action.payload.ops] = action.payload.config;
    },
    updateOpsConfig: (
      state,
      action: PayloadAction<{ ops: string; config: Partial<OpsConfig> }>
    ) => {
      if (state.opsConfigs[action.payload.ops]) {
        state.opsConfigs[action.payload.ops] = {
          ...state.opsConfigs[action.payload.ops],
          ...action.payload.config,
        };
      }
    },
    clearOps: (state) => {
      state.currentOps = null;
      state.availableOps = [];
    },
    setFetchingConfig: (
      state,
      action: PayloadAction<{ ops: string; fetching: boolean }>
    ) => {
      state.fetchingConfigs[action.payload.ops] = action.payload.fetching;
    },
  },
});

export const {
  setCurrentOps,
  setAvailableOps,
  addOpsConfig,
  updateOpsConfig,
  clearOps,
  setFetchingConfig,
} = opsSlice.actions;
export default opsSlice.reducer;
